import { useState, useEffect } from 'react'
import { Invoices } from './Invoices'
import { SubscriptionInfo } from './SubscriptionInfo'
import { Button } from 'reactstrap'
import { makePaymentsGetRequest } from 'utils/api'
import { redirectToStripePortal } from '../helpers'
import { PLANS_STRIPE_URLS } from '../constants'
import { getHelpUserEmail } from 'utils/helpers'
import s from './Subscription.scss'

const Subscription = ({ users, stripeId, isFreeTrial, subscriptionInfo }) => {
  const [stripeConfig, setStripeConfig] = useState({})

  useEffect(() => {
    ;(async () => {
      const result = await makePaymentsGetRequest('/v1/subscriptions/init')
      setStripeConfig(result)
    })()
  }, [])

  const addPaymentInfo = async () => {
    redirectToStripePortal(stripeConfig, stripeId, PLANS_STRIPE_URLS)
  }

  return (
    <>
      <Button onClick={addPaymentInfo} className={s.greenBtn}>
        Manage Billing Info
      </Button>
      <SubscriptionInfo
        users={users.filter(u => u.active && u.email !== getHelpUserEmail())}
        freeTrial={isFreeTrial}
        subscriptionInfo={subscriptionInfo}
      />
      {!isFreeTrial && <Invoices subscriptionInfo={subscriptionInfo} />}
    </>
  )
}

export default Subscription
